import { userIPs } from "@/packages/common/src/server/apiRequests";
import { Office, Prisma, User } from "@/prisma/prismadb";
import { GrantedRole } from "../app/api/postUserInheritRole/route";
import { SafeUser } from "./stripSensitiveUserData";
import { RoleInherited } from "../lib/auth/authorization";

export type ServerSideUserWithOffice = User & {
  office?: Office | null;
  roleInherited?: RoleInherited | Prisma.JsonValue;
  grantedRole?: GrantedRole | Prisma.JsonValue;
};

export type SafeUserWithOffice = SafeUser & {
  office?: Office | null;
};

export type FullUserWithOffice = User & {
  office?: Office | null;
};

export type PartialSafeUserWithOffice = Partial<SafeUserWithOffice>;

export async function getUsersCurrentLatLong(IPs?: (userIPs | null)[] | null) {
  if (!IPs) return null;
  // Find the most recent IP obj, by most recent IPs.lastLogin, lastLogin is a Date object or null
  const mostRecentIP = IPs.sort((a, b) => {
    if (!a?.lastLogin || !b?.lastLogin) return 0;
    const dateA = a.lastLogin ? new Date(a.lastLogin).getTime() : 0; // Default to 0 if null
    const dateB = b.lastLogin ? new Date(b.lastLogin).getTime() : 0; // Default to 0 if null
    return dateB - dateA;
  })[0];
  if (!mostRecentIP) return null;
  return mostRecentIP.latLong;
}

export function userIsOfficeOwner(userObj: Record<string, any>): boolean {
  return !!userObj?.office?.ownerId && !!userObj?.id && userObj?.office?.ownerId === userObj?.id;
}
